export const useAppbarEventStore = defineStore('appbarEventStore', () => {
  const buttons = ref([])
  const eventFired = ref(null)
  const parent = ref(null)
  const showButtons = ref(true)

  const setButtons = listOfButtons => {
    $reset()
    buttons.value = listOfButtons
    buttons.value.unshift({ label: 'Cancel', color: 'secondary', event: 'cancel' })
  }

  const $event = eventFiredInFront => {
    eventFired.value = eventFiredInFront
  }

  const $reset = () => {
    buttons.value = []
    eventFired.value = null
  }

  function onlyCancelButton() {
    buttons.value = [{ label: 'Cancel', color: 'secondary', event: 'cancel' }]
  }

  function cancelChanges() {
    if (parent.value) {
      router.push(parent.value)
    } else {
      router.push(levelUpRoute())
    }
  }

  function modifyParent(value) {
    parent.value = value
  }

  function levelUpRoute() {
    const url = window.location.pathname
    const splitted = url.split('/')
    splitted.pop()

    if (url.match('edit')) {
      splitted.pop()
    }
    return splitted.join('/')
  }

  const router = useRouter()
  router.beforeEach(async (to, from) => {
    if (to.fullPath !== from.fullPath) {
      $reset()
    }
  })

  return { $reset, $event, setButtons, buttons, eventFired, cancelChanges, modifyParent, onlyCancelButton, showButtons }
})
